import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OfferPagePromoLandings } from './OfferPagePromoLandings';
import { actions } from './OfferPagePromoLandings.actions';
import {
    getHeaderNames,
    getLandings,
    getLandingsGallery,
    getHostingTypes,
    getProportions
} from './OfferPagePromoLandings.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    landings: getLandings,
    landingsGallery: getLandingsGallery,
    hostingTypes: getHostingTypes,
    proportions: getProportions
});

const OfferPagePromoLandingsComponent = connect(
    function mapStateToProps(state, {showConstructor, showConstructorPromoCode, showConstructorPromoCodeList}) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.landings.loading,
            totalPages: state.landings.total,
            showConstructor: showConstructor,
            showConstructorPromoCode: showConstructorPromoCode,
            showConstructorPromoCodeList: showConstructorPromoCodeList
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getLandings: actions.getLandings,
            saveLanding: actions.saveLanding
        };
    }
)(OfferPagePromoLandings);

export default OfferPagePromoLandingsComponent;
